import { render, staticRenderFns } from "./Trm.vue?vue&type=template&id=8e813962"
import script from "./Trm.vue?vue&type=script&lang=js"
export * from "./Trm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e813962')) {
      api.createRecord('8e813962', component.options)
    } else {
      api.reload('8e813962', component.options)
    }
    module.hot.accept("./Trm.vue?vue&type=template&id=8e813962", function () {
      api.rerender('8e813962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Trm.vue"
export default component.exports